import { IEligibilityNote } from '@/Models/IEligibilityNote';
import { ITypedValidationResult } from '@/Models/IValidationResult';
import { BaseApiService } from './base-api-service';

class eligibilitytNoteService extends BaseApiService {
    public constructor() {
        super('EligibilityNote/');
    }

    public async getByEligibilityId(eligibilityId: number): Promise<IEligibilityNote[]> {
        return this.httpClient.get<IEligibilityNote[]>(`GetByEligibilityId/${eligibilityId}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async save(note: IEligibilityNote): Promise<ITypedValidationResult<IEligibilityNote>> {
        return this.httpClient.post<ITypedValidationResult<IEligibilityNote>>("save", note).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async delete(noteId: number): Promise<void> {
        return this.httpClient.delete<void>(`delete/${noteId}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }
}

export const EligibilityNoteService: eligibilitytNoteService = new eligibilitytNoteService();